function SubmitButton({ loading, buttonText, loadingText, disabled = false }) {
  return (
    <button
      type="submit"
      className="mt-6 w-full bg-brand-orange text-white font-extrabold rounded-form py-3 text-lg shadow-sm transition hover:bg-orange-500 focus:ring-4 focus:ring-brand-orange/30 disabled:opacity-60"
      disabled={loading || disabled}
    >
      {loading ? loadingText : buttonText}
    </button>
  );
}

export default SubmitButton;